export const COURSE_MAP = {
  NORMAL: {
    code: '01',
    label: '標準コース',
  },
  LEEWAY: {
    code: '02',
    label: 'ゆとりコース',
  },
  LONG_TERM: {
    code: '03',
    label: '長期コース',
  },
  THIRTY_THOUSAND: {
    code: '04',
    label: '3万円',
  },
  FIFTY_THOUSAND: {
    code: '05',
    label: '5万円',
  },
  HUNDRED_THOUSAND: {
    code: '06',
    label: '10万円',
  },
}

export const COURSE_LIST = [
  COURSE_MAP.NORMAL,
  COURSE_MAP.LEEWAY,
  COURSE_MAP.LONG_TERM,
  COURSE_MAP.THIRTY_THOUSAND,
  COURSE_MAP.FIFTY_THOUSAND,
  COURSE_MAP.HUNDRED_THOUSAND,
]
